import * as localforage from "localforage";
import axios from "axios";
import { errorHandling } from "../helpers/errorHandling";
import { url } from "../apis/apiSetup";
import requestRetry from "@/apis/requestRetry";
import { ajaxRetrySetup } from "@/helpers/jquery.ajax-retry";
import { APP_ENV } from "@/APP_ENV";

export const LOCALFORAGE_INITIATE = () => {
  if (!require.cache[require.resolveWeak("localforage")]) {
    console.log(
      "Missing locaforage package, please refer https://github.com/localForage/localForage"
    );
  }

  /**
   * driver - set priority for local db egnine, in case browser doesn't support, will fallback one by one.
   */
  if (require.cache[require.resolveWeak("localforage")]) {
    localforage.config({
      driver: [
        localforage.INDEXEDDB,
        localforage.WEBSQL,
        localforage.LOCALSTORAGE
      ],
      name: APP_ENV.REACT_APP_LOCALFORAGE_NAME || window.location.hostname,
      size: APP_ENV.REACT_APP_LOCALFORAGE_SIZE || 65536000,
      storeName: APP_ENV.REACT_APP_LOCALFORAGE_STORENAME || "keyvaluepairs",
      description:
        APP_ENV.REACT_APP_LOCALFORAGE_DESCRIPTION || "Store data to local"
    });
  }
};

export const initAxiosInterceptors = () => {
  let timer;

  requestRetry(axios);
  ajaxRetrySetup();

  axios.interceptors.request.use(
    async config => {
      const token = await localforage.getItem("token");
      const company_id = await localforage.getItem("currentCompanyId");
      const lang = localStorage.getItem("rcml-lang");
      config.baseURL = url;
      config.headers.Accept = "application/json";
      config.headers.Authorization = "Bearer " + token;
      config.headers.AcceptLanguage = lang || "en";
      if (!config.params) {
        config.params = {};
      }
      if (!config.data) {
        config.data = {};
      }
      if (!config.params.company_id) {
        config.params.company_id = company_id;
      }
      if (typeof config.data === "object") {
        if (config.data instanceof FormData) {
          if (!config.data.get("company_id")) {
            config.data.append("company_id", company_id);
          }
        } else if (!config.data.company_id) {
          config.data.company_id = company_id;
        }
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      return response;
    },
    err => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      timer = setTimeout(() => {
        if (err.name === "CanceledError") {
          return;
        }
        errorHandling(err);
      });

      const { code, message } = err.response?.data ?? {};
      if (code === 403 || code === '403') {
        if (message) toast.error(message)
      }

      return Promise.reject(err);
    }
  );
};
